import React from 'react'
import withView from '../../../cmn/docAutomation/withView';
import FormDialog from '../../../../library/form/components/FormDialog';
import FormInput from '../../../../library/form/components/FormInput';
import FormTitle from '../../../../library/form/components/FormTitle'
import FormLabel from '../../../../library/form/components/FormLabel'
import FormROValue from '../../../../library/form/components/FormROValue1';

const CategoryMasterSH = (props) => {
    const { formObject, viewData, ...restProps } = props;

    return (
        <FormDialog onDynamicViewClose={restProps.onDynamicViewClose} enablePopup={true}
            action={{ actionParam:{showModeID: 'sh'}, formActions: { forAction: "Confirm", forCancel: "Cancel" } }}
            formStyle={{ width: '350px' }}
            formTitle={<FormTitle formObject={formObject} value='Category Master' />}
            formObject={formObject} >
            <div>
                <div className="uiRow uiSpacer15">
                    <span className="uiLbl">
                        <FormLabel formObject={formObject} rowKey="" action={{ paramName: "docID" }} value="ID" />
                    </span>
                    <FormROValue format="#" formObject={formObject} rowKey="" action={{ paramName: "docID" }} />
                </div>
                <div className="uiRow uiSpacer15">
                    <span className="uiLbl">
                        <FormLabel formObject={formObject} rowKey="" action={{ paramName: "cmName" }} value="Category Name" />
                    </span>
                    <FormInput formObject={formObject} rowKey="" autofocus action={{ InputType: "input", paramName: "cmName" }} />
                </div>
            </div>
        </FormDialog>
    )
}

export default withView(CategoryMasterSH, "catMaster", "");